import React from 'react';
import '../styles/Header.css'; // Asegúrate de tener un archivo CSS para personalizaciones adicionales
import logo from '../images/logo_1.png';

const HeaderComponent = ({ title }) => {
    return (
        <div style={{ width: "100%", display: "flex", justifyContent: "center", marginBottom: "0.6rem" }}>

            <div 
                style={{ 
                    minWidth: "95%", 
                    maxWidth: "95%",
                    backgroundColor: "#2C3E50", // Un tono azul oscuro
                    margin: "0.6vw", 
                    borderRadius: "10px", 
                    boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)", // Sombra sutil
                    display: "flex", 
                    alignItems: "center", 
                    padding: "15px 30px" // Padding para más espacio
                }}
            >
                <p style={{ margin: 0, color: "white", fontSize: "1.5rem", fontWeight: "600" }}>
                    {title}
                </p>
            </div>
        </div>
    );
};

export default HeaderComponent;

